export const REVALIDATE_SECONDS = 300;

export const ITEMS_LIMIT = 24;
